<script setup lang="ts">
import { Head, Link } from '@inertiajs/vue3'
import { ArrowLeft } from 'lucide-vue-next'

import ApplicationForm from '@/components/app/applications/ApplicationForm.vue'
import PortalLayout from '@/layouts/PortalLayout.vue'
import { portalOrganizationApplicationsPath } from '@/routes'

defineProps<{
  genders: string[]
  loan_terms: number[]
  purposes: Record<string, string[]>
  loan_types: string[]
  marital_statuses: string[]
  living_statuses: string[]
}>()
</script>

<template>
  <Head title="New Application" />
  <PortalLayout actor-type="organization">
    <div class="mx-auto max-w-3xl space-y-6">
      <div class="flex items-center gap-3">
        <Link :href="portalOrganizationApplicationsPath()" class="text-muted-foreground hover:text-foreground">
          <ArrowLeft class="size-4" />
        </Link>
        <h1 class="text-xl font-semibold">New Application</h1>
      </div>

      <ApplicationForm
        :submit_url="portalOrganizationApplicationsPath()"
        :show-partner-selector="true"
        :genders="genders"
        :loan_terms="loan_terms"
        :purposes="purposes"
        :loan_types="loan_types"
        :marital_statuses="marital_statuses"
        :living_statuses="living_statuses"
      />
    </div>
  </PortalLayout>
</template>
